<template>
  <div class="styleCard">
    <ul class="style-nav style2">
      <li
        v-for="tab in TimeFrameTabs"
        :key="tab.id"
        :class="{ active: selectedTimeGraph === tab.alias }"
        @click="selectedTimeGraph = tab.alias"
      >
        {{ tab.name }}
      </li>
    </ul>
    <ul class="style-nav style2">
      <li
        v-for="tab in TiersTabs"
        :key="tab.id"
        :class="{ active: selectedTierOption === tab.alias }"
        @click="selectedTierOption = tab.alias"
      >
        {{ tab.name }}
      </li>
    </ul>
    <ul class="style-nav style2">
      <li
        v-for="tab in FilterTabs"
        :key="tab.id"
        :class="{ active: selectedFilter === tab.alias }"
        @click="selectedFilter = tab.alias"
      >
        {{ tab.name }}
      </li>
    </ul>
    <avg-daily-charts
      :selectedTimeFrame="selectedTimeGraph"
      :selectedTier="selectedTierOption"
      :selectedFilter="selectedFilter"
    ></avg-daily-charts>
  </div>
</template>

<script>
import AvgDailyCharts from "../components/AvgDailyCharts.component";

export default {
  components: {
    AvgDailyCharts
  },
  name: "Avg.container",
  data() {
    return {
      selectedTimeGraph: 7,
      selectedTierOption: null,
      selectedFilter: "ALL",
      TimeFrameTabs: [
        {
          id: 0,
          name: "7",
          alias: 7
        },
        {
          id: 1,
          name: "30",
          alias: 30
        },
        {
          id: 2,
          name: "90",
          alias: 90
        },
        {
          id: 3,
          name: "180",
          alias: 180
        }
      ],
      FilterTabs: [
        {
          id: 0,
          name: "ALL",
          alias: "ALL"
        },
        {
          id: 1,
          name: "DUP",
          alias: "DUP"
        },
        {
          id: 2,
          name: "REG",
          alias: "REG"
        }
      ],
      TiersTabs: [
        {
          id: 0,
          name: "ALL",
          alias: null
        },
        {
          id: 1,
          name: "Tier 1",
          alias: 1
        },
        {
          id: 2,
          name: "Tier 2",
          alias: 2
        },
        {
          id: 3,
          name: "Tier 3",
          alias: 3
        },
        {
          id: 4,
          name: "Tier 4",
          alias: 4
        }
      ]
    };
  }
};
</script>

<style scoped>
.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  overflow: hidden;
  height: max-content;
  min-width: 300px;
  position: absolute;
  margin: auto;
  top: 100px;
  right: 0;
  left: 0;
  width: 99%;
  font-family: Montserrat;
}

.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
			background: white;
		      */
}
.style-nav.style2 li {
  /*border-radius: 5px 5px 0px 0px;*/
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 72px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(4px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
  /* transform: translateY(4px);*/
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
</style>
